import Badge from '@mui/material/Badge';
import type { FC, ReactNode } from 'react';

interface BadgeProps {
  id: string;
  children?: ReactNode;
  variant?: 'dot' | 'standard';
  alignVertical?: 'top' | 'bottom';
  alignHorizontal?: 'right' | 'left';
  badgeContent?: ReactNode;
  color?:
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'info'
  | 'warning'
  | 'default';
  invisible?: boolean;
  showZero?: boolean;
  className?: string;
  max?: number;
  overlap?: 'circular' | 'rectangular';
}

const CustomBadge: FC<BadgeProps> = ({
  id,
  children,
  className,
  variant,
  max,
  color = 'default',
  alignVertical = 'top',
  alignHorizontal = 'right',
  badgeContent,
  showZero = false,
  overlap,
  ...rest
}) => {
  return (
    <Badge
      id={id}
      variant={variant}
      className={className}
      badgeContent={badgeContent}
      max={max}
      color={color}
      showZero={showZero}
      anchorOrigin={{
        vertical: alignVertical,
        horizontal: alignHorizontal,
      }}
      overlap={overlap}
      {...rest}
    >
      {children}
    </Badge>
  );
};

export default CustomBadge;
